import Vue from 'vue'
import App from './App.vue'
import 'es6-promise/auto'
import Mint from 'mint-ui'
import moment from 'moment'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

import router from './router'
import store from './store'
import utils from './util/util'

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

import 'mint-ui/lib/style.css'
import './assets/style/iconfont/iconfont.css'
import './assets/style/common.scss'

// i18
import VueI18n from 'vue-i18n'
import i18n from './lang/index'
// copy
import VueClipboard from 'vue-clipboard2'

// 注册全局组件
import GoBuyHead from './h5components/GoBuyHead.vue'
Vue.component('gobuy-head', GoBuyHead);

Vue.use(VueClipboard)



import { Image as VanImage, Progress, Stepper, Popup, ImagePreview, Dialog } from 'vant';
import { Lazyload } from 'vant';
import 'vant/lib/image/style';
import 'vant/lib/progress/style';
import 'vant/lib/stepper/style';
import 'vant/lib/popup/style';
import 'vant/lib/image-preview/style';
import 'vant/lib/dialog/style';

Vue.use(Lazyload);
Vue.use(VanImage);
Vue.use(Progress);
Vue.use(VueClipboard)
Vue.use(Stepper);
Vue.use(Popup);
Vue.use(ImagePreview);
Vue.use(Dialog);

Vue.use(VueAwesomeSwiper, /* { default options with global component } */);

Vue.use(Mint)
// import no_image from './assets/image/no_image.jpg'
// Vue.use(Mint, {
//   lazyload: {
//     loading: no_image,
//     attempt: 0,
//   },
// });


Vue.prototype.utils = utils;

const isIframe = new Vue({
  data: {
    is_iframe: false
  }
});
Vue.prototype.$IFR = isIframe;

moment.locale('zh-cn')
Vue.prototype.$moment = moment
Vue.config.productionTip = false

new Vue({
  VueI18n,
  i18n,
  store,
  router,
  render: h => h(App),
}).$mount('#app')
// new Vue({
//     el: '#app',
//     store,
//     router,
//     components: { App },
//     template: '<App/>'
// })
